import React, { useState, useEffect } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { Rating } from '@material-ui/lab';
import Header from "../../ui/Header"
import Container from "../../ui/Container"
import PageTitle from "../../ui/PageTitle"
import { Link } from "react-router-dom";
import "../Product.css"
import "./index.css"



const Feedbacks = ({ translation, ...props }) => {

    const [messages, setMessages] = useState([])
    useEffect(() => {
        axios(`/get_all_feedbacks/`).then(res => {
            const sortedData = res.data.sort((a, b) => b.time - a.time)
            setMessages(m => m.concat(sortedData))
        })
    }, [])

    return (
        <div className="Collection Feedbacks">
            <Header />
            <div className="Collection--category">
                <PageTitle title={translation.language === "ua" ? "Відгуки" : "Отзывы"} />
                <Container>
                    <ul className="Feedbacks--list">
                        {messages.map(message => {
                            return (
                                <li key={message.id}>
                                    <Link
                                        to={`/products/${message.product_id}`}
                                        className="feedback-message feedback-page-message"
                                    >
                                        <img
                                            className="feedback-page-image"
                                            src={process.env.REACT_APP_API + "/media/" + message.product_image.split(",")[0]}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <div className="feedback-container">
                                            <div className="feedback-top">
                                                <div>
                                                    <p className="feedback-author">{message.user_name}</p>
                                                    <span className="feedback-date">{new Date(message.time * 1000).toLocaleDateString()}</span>
                                                </div>

                                                <Rating name="read-only" value={message.rate} readOnly size="small" />
                                            </div>
                                            <div className="feedback-bottom">
                                                <div className="feedback-text">
                                                    <p>{message.text}</p>
                                                </div>

                                            </div>
                                        </div>

                                    </Link>
                                </li>
                            )

                        })}
                    </ul>
                </Container>
            </div>



        </div >
    )
}

const mapStateToProps = state => {
    return {
        translation: state.translationReducer,
    }
}

export default connect(mapStateToProps)(Feedbacks)
